import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Country } from '../../../models/country.model';
import { COUNTRIES } from './countries.const';

@Component({
  selector: 'flex-privacy-policy-language-selector',
  imports: [NgClass],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  private readonly translateService = inject(TranslateService);
  readonly countries = COUNTRIES;
  readonly selected = signal<Country>(this.countries.find((c) => c.key === 'en-ie')!);
  readonly isOpen = signal(false);
  readonly ariaExpanded = computed(() => String(this.isOpen()));

  toggle() {
    this.isOpen.update((v) => !v);
  }

  close() {
    this.isOpen.set(false);
  }

  private changeLanguage() {
    const locale = this.selected().key;
    const brand = localStorage.getItem('brand') || 'enelx';
    const langTag = `${locale}.${brand.toUpperCase()}`;
    this.translateService.use(langTag);
  }

  select(key: string) {
    const f = this.countries.find((c) => c.key === key);
    if (!f) return;
    this.selected.set(f);
    this.changeLanguage();
    this.close();
  }
}
